import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { useWorkflow } from '../../workflow/hooks';
import { BrandedHeader } from '../BrandedHeader/BrandedHeader';
import { NarvarFooter } from '../NarvarFooter/NarvarFooter';

import s from './Page.module.css';
import { useRetailerSettings } from '../../hooks/useRetailerSettings';

interface PageProps {
  isPublicRoute?: boolean;
  children: ReactNode;
}

export const PageWrap = ({ children }: { children: ReactNode }) => {
  const { isError, isLoading } = useRetailerSettings();
  return (
    <div className={s.container}>
      {!isError && !isLoading && <BrandedHeader />}
      {children}
      <NarvarFooter />
    </div>
  );
};

export const Page = (props: PageProps) => {
  const { children } = props;
  const navigate = useNavigate();
  const { isAuthenticated } = useWorkflow();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate({ to: '/', replace: true, search: true });
    }
  }, [isAuthenticated, navigate]);

  return <PageWrap>{children}</PageWrap>;
};
